import { useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { ArrowUpRight, Check, Users } from "lucide-react";
import { toast } from "sonner";
import { fadeUp, stagger, viewport } from "../motion";
import { IMAGES, serviceOptions } from "../data";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const Contact = ({ selectedService, setSelectedService }) => {
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const submitRequest = async (event) => {
    event.preventDefault();
    const formEl = event.currentTarget;
    setLoading(true);
    const data = Object.fromEntries(new FormData(formEl).entries());
    try {
      await axios.post(`${API}/meeting-requests`, data);
      setSubmitted(true);
      toast.success("Pedido enviado! Vamos entrar em contato.");
      formEl.reset();
    } catch (error) {
      toast.error("Não foi possível enviar agora. Tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="section contact" id="contact" data-testid="contact-section">
      <motion.div className="contact-copy" initial="hidden" whileInView="show" viewport={viewport} variants={stagger}>
        <motion.p className="eyebrow" variants={fadeUp}><span className="eyebrow-dot" /> Vamos começar</motion.p>
        <motion.h2 variants={fadeUp}>Pronto para<br /><em>mudar o jogo?</em></motion.h2>
        <motion.p variants={fadeUp}>Conte um pouco sobre o seu momento. Nossa equipe vai analisar seu cenário e entrar em contato para confirmar uma conversa.</motion.p>
        <motion.div className="meet-note" variants={fadeUp}>
          <span className="note-icon"><Users size={18} /></span>
          <span>Reunião online via Google Meet<br /><small>Após a confirmação, enviaremos o link por e-mail.</small></span>
        </motion.div>
        <motion.div className="contact-media" variants={fadeUp}>
          <img src={IMAGES.meeting} alt="Reunião online de estratégia com cliente" />
        </motion.div>
      </motion.div>

      <motion.form className="form-card" onSubmit={submitRequest} data-testid="meeting-request-form" initial="hidden" whileInView="show" viewport={viewport} variants={fadeUp}>
        {submitted ? (
          <div className="success-state" data-testid="meeting-success-message">
            <div className="success-icon"><Check /></div>
            <h3>Pedido recebido.</h3>
            <p>Obrigado pelo interesse. Em breve, nossa equipe vai falar com você para confirmar o melhor horário.</p>
            <button type="button" className="btn-ghost" onClick={() => setSubmitted(false)} data-testid="new-request-button">Enviar outro pedido <ArrowUpRight size={16} /></button>
          </div>
        ) : (
          <>
            <div className="form-head"><span>Solicite uma conversa</span><small>Leva menos de 2 minutos</small></div>
            <label>Seu nome<input name="name" required placeholder="Como podemos te chamar?" data-testid="meeting-name-input" /></label>
            <label>E-mail corporativo<input type="email" name="email" required placeholder="voce@empresa.com" data-testid="meeting-email-input" /></label>
            <label>WhatsApp<input name="whatsapp" required placeholder="(00) 00000-0000" data-testid="meeting-whatsapp-input" /></label>
            <label>Qual solução faz sentido agora?
              <select name="service" value={selectedService} onChange={(e) => setSelectedService(e.target.value)} data-testid="meeting-service-select">
                {serviceOptions.map((option) => <option key={option}>{option}</option>)}
              </select>
            </label>
            <button className="btn-gold form-submit" type="submit" disabled={loading} data-testid="meeting-submit-button">
              {loading ? "Enviando..." : "Solicitar minha conversa"} <ArrowUpRight size={17} />
            </button>
            <small className="privacy">Seus dados estão seguros. Sem spam, só uma conversa honesta.</small>
          </>
        )}
      </motion.form>
    </section>
  );
};
